import { z } from 'zod'

export const APP_ENV = z.enum(['dev', 'prod', 'test']).parse(import.meta.env.VITE_APP_ENV)
export const SERVER_PORT = z.coerce.number().parse(import.meta.env.VITE_SERVER_PORT)
export const CLIENT_PORT = z.coerce.number().parse(import.meta.env.VITE_CLIENT_PORT)

// Vite exposes environment variables prefixed with VITE_ to client code
export const API_BASE_URL = z.string().parse(import.meta.env.VITE_API_BASE_URL)
